import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import './App.scss';
import Footer from './components/Footer';
import Header from './components/Header';
import Layout from './components/UI/Layout';
import Screen from './components/UI/Screen';
import Introduction from './pages/Introduction';
import AboutMe from './pages/AboutMe';
import Projects from './pages/Projects';
import Experience from './pages/Experience';
import Contact from './pages/Contact';
import AdminLogin from './components/Admin/AdminLogin';
import AdminSection from './components/Admin/AdminSection';

function App() {
  return (
    <Router>
      <Layout>
        <Header />
        <Screen>
          <Routes>
            <Route exact path='/' element={<Introduction />} />
            <Route exact path='/about' element={<AboutMe />} />

            <Route exact path='/projects' element={<Projects />} />
            <Route exact path='/experience' element={<Experience />} />
            <Route exact path='/contact' element={<Contact />} />
            <Route path='/login' element={<AdminLogin />} />
            <Route path='/admin' element={<AdminSection />} />
          </Routes>
        </Screen>

        <Footer />
      </Layout>
    </Router>
  );
}

export default App;
